import React from 'react';
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types';
import OrdinationPage from './ordination_page';

class PostOrdination extends OrdinationPage {
  componentDidMount() {
    this.returnSessionKey()
    this.pushAnalyticsEvent(); // Call the function to push analytics event
  }
  courseImagePath() {
    return document.getElementById('ordination').getAttribute('data-course-image-path');
  }

  mopImagePath() {
    return document.getElementById('ordination').getAttribute('data-mop-image-path');
  }

  certProdImagePath() {
    return document.getElementById('ordination').getAttribute('data-certificate-product-image-path');
  }

  bookProdImagePath() {
    return document.getElementById('ordination').getAttribute('data-book-product-image-path');
  }

  logsProdImagePath() {
    return document.getElementById('ordination').getAttribute('data-logs-product-image-path');
  }

  pushAnalyticsEvent() {
    const userEmail = this.props.minister.email; // Fetch the user's email address here
    if (userEmail) {
      console.info(userEmail);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ordination_confirmation',
        userEmail: userEmail, // Add the user's email address to the event
      });
    } else {
      console.info("No user email");
    }
  }

  async returnSessionKey(){
    const domain = window.location.host;
    const protocol = window.location.protocol;
    const url = protocol +"//"+domain+"/session_return";
    console.debug("url: " + url)
    const res = await fetch(url);
    const res_json = await res.json();
    console.debug("courses: " + res_json["courses"])
    console.debug("boo: " + res_json["boo-course"])
    if(res_json["courses"] == "false"){
      console.info("FALSE for AMM Courses referral link");
    }
    else if (res_json["courses"] == "true") {
      console.info("TRUE for AMM Courses referral link.");
      var success_html = (
        <div>
          <div className='post_ord_step course_panel'>
            <h3>CONTINUE ENROLLMENT</h3>
            <h2>Professional Wedding Officiant Certification Course</h2>
            <a className='cta' href='https://courses.theamm.org/wp-login.php?redirect_to=https%3A%2F%2Fcourses.theamm.org%2Fpurchase-amms-professional-wedding-officiant-course/%2F'>GO TO COURSE</a>
            <img className="courses_emblem" src={ this.courseImagePath() }/>
          </div>
        </div>
      )
      ReactDOM.render(success_html, document.getElementById('post_ord_step_4'));
    }
    else if (res_json["boo-course"] == "true") {
      console.info("TRUE for BOO Course referral link.");
      var success_html = (
        <div>
          <div className='post_ord_step course_panel'>
            <h3>CONTINUE ENROLLMENT</h3>
            <h2>Elevate by Bethel's Business of Officiating Course</h2>
            <a className='cta' href='https://courses.theamm.org/wp-login.php?redirect_to=https%3A%2F%2Fcourses.theamm.org%2Fpurchase-elevate-by-bethels-business-of-officiating-course%2F'>GO TO COURSE</a>
            <img className="courses_emblem" src={ this.courseImagePath() }/>
          </div>
        </div>
      )
      ReactDOM.render(success_html, document.getElementById('post_ord_step_4'));
    }
    else{
      console.info("No referral link from AMM Courses site.")
    }
  }

  render() {
    return (
      <div className={ this.props.className } id='product-panel'>
        <div className='line'></div>
        <p className='what_next'>
          What's Next?
        </p>
        <div className='line'></div>
        <div id='post_ord_step_4'></div>
        <div className='post_ord_step'>
          <h2>1. Get Your Minister Ordination Package</h2>
          <p>
            Local governments often require physical proof of ordination. Get your Minister Ordination Package now for full accreditation. Don't get caught without your required credentials when it's time to perform a wedding.
          </p>
          <img className='mop_img' src={ this.mopImagePath() }/>
          <a className='cta' href='/store/products/minister-ordination-package'>ORDER NOW!</a>
          <h4>
            Your Package Includes Your:
          </h4>
          <div className='l-columns-500-4 mop_contents'>
            <img src={ this.certProdImagePath() }></img>
            <p>Official Ordination Certificate</p>
          </div>
          <div className='l-columns-500-4 mop_contents'>
            <img src={ this.bookProdImagePath() }></img>
            <p>AMM Minister's Manual</p>
          </div>
          <div className='l-columns-500-4 mop_contents'>
            <img src={ this.logsProdImagePath() }></img>
            <p>Signed and Notarized Letter of Good Standing</p>
          </div>
          <div className='clearboth'></div>
        </div>
        <div className='line'></div>
        <div className='post_ord_step'>
          <h2>2. Register Your Wedding</h2>

          <p>
            After you have obtained any required credentials, the next step is to plan the ceremony. Our "<a href='/weddings/new'>AMM Wedding Helper</a>" tool allows you to register your wedding, create customized ceremony scripts, and guides you through the entire process of officiating a wedding.
            <br /><br />
            Our Wedding Helper also lets you post and share pictures, stories, and other memorable moments from the wedding for other ministers and guests to see. American Marriage Ministries is committed to your success as an officiant, and we offer the tools and guidance that you need. Start out by registering your wedding.
          </p>

        </div>
        <div className='line'></div>
        <div className='post_ord_step'>
          <h2>3. Complete Your Minister Profile</h2>
          <p>
            Your minister profile allows you to tell others about yourself, and show off weddings that you have performed. Want to perform more weddings? Want your friends and family to be able to see weddings that you have performed? <a id="continue" href={`/ministers/${this.props.minister.id}/profile`}>Complete your profile</a> and show couples and other ministers the ceremonies you have officiated.
            <br /><br />
            With settings that let you decide who sees your profile (we also have privacy settings) we give our ministers complete control over what the world sees, and what they want to say.
          </p>
        </div>

        
      </div>
    );
  }
}

PostOrdination.propTypes = {
  minister: PropTypes.object.isRequired
};

export default PostOrdination;
